export const Alerts = {
alertClass: {
    success: 'alert--success',
    error: 'alert--error',
    warning: 'alert--warning',
    info: 'alert--info',
},
}